import { Component } from '@angular/core';

@Component({
  selector: 'app-guest-page',
  templateUrl: './guest-page.component.html',
  styleUrls: ['./guest-page.component.css'],
  standalone: false
})
export class GuestPageComponent {}
